<template>
  <div>
    <img
      src="@/assets/tarjeta_servicios_oficina_referencia.jpg"
      style="width: 100%"
    />

    <p class="tituloTarjeta">OFICINA DE REFERENCIA</p>
    <p>
      Contacta con tu asesor comercial personalizado para realizar cualquier
      gestión relacionada con tus pólizas, recibos o siniestros.
    </p>
    <p>Serás atendido por personal cualificado para darte el mejor servicio</p>

    <p class="container-flex">
      <a :href="'tel:' + telefonoOwner">
        <button
          class="pure-button botonLlamar"
          title="Pulsa el botón para llamar a tu oficina MMT"
        >
          Llamar
        </button>
      </a>

      <button
        class="pure-button botonLlamar"
        title="Pulsa el botón para ponernos en contacto contigo"
        @click.prevent="confirmTel(true)"
      >
        Te llamamos
      </button>

      <TeLlamamosConfirmTel
        v-if="popUpConfirmTel"
        :telefono-inic="$store.state.portfolio.cliente.telefono"
        :asunto-inic="asunto()"
        @close="confirmTel(false)"
      />
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      popUpConfirmTel: false,
      telefonoOwner:
        this.$store.state.portfolio.cliente.telefonoOwnerPropioCliente,
    };
  },

  methods: {
    asunto() {
      return "CONTACTO_OFICINA";
    },
    confirmTel(val) {
      this.popUpConfirmTel = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.container-flex {
  margin-top: 2.5rem;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
  width: 9rem;
  border: 0.15rem solid;
  text-align: center;
  border-radius: 0.5rem;
}

// .container-flex a:first-child {
//   margin-right: 15%;
// }
</style>
